'use strict';

angular.module('study.ecrd.field.queries')
    .controller('FieldCloseQueryController', ['$scope', 'CrdConfigurationService', function($scope, CrdConfigurationService) {
        var vm = this;

        // Model
        vm.query = {
            text: '',
        };

        vm.messages = CrdConfigurationService.getQueries().getFixedMessages().close;
        vm.hasPresetMessages = vm.messages && vm.messages.length > 0;

        vm.allowManualInput = false;
        vm.requireManualInput = false;

        vm.fixedMessage = null;

        // Control de error para incluir el mensaje teniendo en cuenta las opciones predefinidas si hay
        vm.error = {};

        // Actions
        vm.closeQuery = function() {
            if (vm.fixedMessage) {
                if (vm.query.text) {
                    vm.query.text = [vm.fixedMessage.message, vm.query.text].join('\n');
                } else {
                    vm.query.text = vm.fixedMessage.message;
                }
            }

            $scope.closeThisDialog(vm.query);  // eslint-disable-line angular/controller-as
        };

        vm.closeModal = function() {
            $scope.dismissThisDialog('entity-note-close-cancelled'); // eslint-disable-line angular/controller-as
        };

        vm.setFixedMessage = function() {
            if (vm.fixedMessage) {
                vm.allowManualInput = vm.fixedMessage.manual !== 'forbid';
                vm.requireManualInput = vm.fixedMessage.manual === 'require';
            } else {
                // Si hay mensajes prefijados significa que no se ha elegido ninguno, primero hay que elegir uno válido
                // Si no hay mensajes predefinidos, entonces la introducción manual es siempre obligatoria
                vm.allowManualInput = !vm.hasPresetMessages;
                vm.requireManualInput = false; // Se pueden cerrar queries sin un texto
            }

            if (!vm.allowManualInput && vm.manualReason) {
                // Actualizar mensaje manual vacío si no se requiere
                vm.query.text = '';
            }
        };

        // Inicialización de las variables de control
        vm.setFixedMessage();
    }]);
